module.exports = __webpack_public_path__ + "media/images/oak/avatars/avatar-1-df4a5fbfe373badaf937f86f391f5028.png";